import { tenantDTOSchema } from '@instanexus/contracts';
import { listEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const listTenantsSchema = listEnvelopeSchema(tenantDTOSchema);
export function createTenantsResource(transport) {
    return {
        async list(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/tenants`,
                schema: listTenantsSchema,
                query: { page: params.page, pageSize: params.pageSize, sort: params.sort, q: params.q },
            });
        },
    };
}
//# sourceMappingURL=tenants.js.map